/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { ConnectButton, SocialProvider, UserLargeIcon } from "@advapacs/common";
import { openWindowOpenOauthURL } from "@src/utils/utils";

interface ConnectSocialModalProps {
  show?: boolean;
  onClose?: () => void;
  onConfirm?: (shouldSkipRemember?: boolean) => void;
}

export const ConnectSocialModal: FC<ConnectSocialModalProps> = ({
  show,
  onClose,
  onConfirm,
}) => {
  const handleLoginWith = async (type: string) => {
    try {
      const rs = await axios.get(`/externalIdentities/connect/${type}`);

      // open popup
      openWindowOpenOauthURL(rs?.data?.redirect);
    } catch {}
  };

  return (
    <Modal
      size={"sm"}
      className="confirm-modal portal-confirm-modal"
      centered
      show={show}
    >
      <Modal.Header>
        <div className="header-logo">
          <img src={UserLargeIcon} alt="User Icon" />
        </div>
        <h3 className="m-t-xs">Connect your accounts</h3>
      </Modal.Header>
      <Modal.Body className="">
        <div className="sub-title m-b-xs text-center">
          Would you like to use your social accounts for future logins?
        </div>
        <div className="m-b-xs">
          <ConnectButton
            className="d-block w-100 m-b-xs"
            type={SocialProvider.GOOGLE}
            onConnect={() => handleLoginWith(SocialProvider.GOOGLE)}
          />
          <ConnectButton
            className="d-block w-100 m-b-xs"
            type={SocialProvider.FACEBOOK}
            onConnect={() => handleLoginWith(SocialProvider.FACEBOOK)}
          />
          <ConnectButton
            className="d-block w-100 m-b-xs"
            type={SocialProvider.APPLE}
            onConnect={() => handleLoginWith(SocialProvider.APPLE)}
          />
        </div>
      </Modal.Body>
      <div className="flex-center flexbox m-t-xs m-b-xs">
        {onConfirm && (
          <button
            className={`btn btn-primary `}
            onClick={() => {
              onConfirm();
            }}
          >
            Skip
          </button>
        )}
        {onClose && (
          <button
            className={`btn btn-secondary ml-2`}
            onClick={() => {
              onClose();
            }}
          >
            Close
          </button>
        )}
      </div>
    </Modal>
  );
};
